export function formatDomainList(names: string[]): string {
  const filtered = names.map((n) => n.trim()).filter(Boolean);
  if (filtered.length === 0) return '';
  if (filtered.length === 1) return filtered[0] ?? '';
  if (filtered.length === 2) {
    const [a, b] = filtered;
    return `${a} and ${b}`;
  }
  const rest = filtered.slice(0, -1);
  const last = filtered[filtered.length - 1] ?? '';
  return `${rest.join(', ')}, and ${last}`;
}
